import { ProjectId, User } from 'api/models';
import { Field, FieldOption } from 'api/tasks';
import { Option } from 'components/atoms/select/types';
import { useProjectSquad } from 'components/molecules/squad-picker/use-squad-options';
import {
  FieldType,
  filterableFieldType,
} from 'components/organisms/tasks/fields';
import { fullName } from 'utils/full-name';
import { getRandomColor } from 'utils/get-random-color';

export const userOption = (user: User): Option => {
  return {
    label: fullName(user),
    value: user.userId,
    color: getRandomColor(user.userId),
    description: user.role?.roleName,
    imageUrl: user.photoUrl,
    logoUrl: user.company.companyLogoUrl,
  };
};

export const usePopulateUsersMetaInFields = (
  fields: Field[],
  projectId: ProjectId,
): Field[] => {
  const { data: squad } = useProjectSquad(projectId);

  return (fields ?? []).map((field) => {
    const type = filterableFieldType(field);

    /* TODO:: Check with product on whether to show non-in-project members and it's cases. */
    if (type === FieldType.MultiUser || type === FieldType.SingleUser) {
      return {
        ...field,
        metaData: {
          ...field.metaData,
          options: squad?.users?.map(userOption) as FieldOption<number>[],
        },
      };
    }

    return field;
  });
};
